<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <footer class="the-footer flex-wrap justify-between" :class="classes">
    <span>
      COPYRIGHT @ 2019 - {{ new Date().getFullYear() }}
      <router-link :to="{ name:'dashboard' }">LAFEI</router-link>
      , All rights Reserved
    </span>
    <span class="md:flex hidden items-center">
      <span class="text-danger font-bold pr-2">LAFEI</span> & Made by Tom Riddle
    </span>
  </footer>
</template>

<script>
export default {
  name: "the-footer",
  props: {
    classes: {
      type: String,
    }
  }
}
</script>
